import {
  Form,
  Input,
  Space,
  theme,
  type FormItemProps,
  type InputProps
} from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { SERVICE_DOMAIN_REGEXP } from 'src/utils'

type Props = {
  label?: string
  name?: string
  inputProps?: InputProps
  extra?: ReactNode
} & FormItemProps

export const DomainNameFormItem = ({
  label,
  name,
  inputProps,
  extra,
  ...fieldProps
}: Props) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const size = inputProps?.size ?? 'large'
  const placeholder = inputProps?.placeholder ?? 'org-name'

  return (
    <Form.Item label={label ?? t('domain')} extra={extra}>
      <Space.Compact block style={{ width: '100%' }}>
        <Form.Item
          name={name ?? 'domain_name'}
          noStyle
          rules={[
            { required: true, message: t('required_field_error') },
            {
              pattern: SERVICE_DOMAIN_REGEXP,
              message: t('invalid_domain_format')
            }
          ]}
          {...fieldProps}
        >
          <Input
            {...inputProps}
            size={size}
            placeholder={placeholder}
            autoComplete="off"
            style={{ ...inputProps?.style, flex: 1, minWidth: 0 }}
          />
        </Form.Item>
        <Input
          readOnly
          tabIndex={-1}
          size={size}
          value=".skalx.ai"
          aria-hidden
          style={{
            width: 88,
            flex: 'none',
            color: token.colorTextSecondary,
            backgroundColor: token.colorFillAlter,
            cursor: 'default',
            pointerEvents: 'none'
          }}
        />
      </Space.Compact>
    </Form.Item>
  )
}
